export const CELL_SIZE_WITH_OUTLINE = 26;

export const WEIGHT = 10;

export const ICON_COLOR = "rgb(66,9,98)";
